import React from 'react';
import PropTypes from 'proptypes';
import { seatsLeftEvaluator, formatDate } from './../../../helpers/TripHelper';
import moment from 'moment';
import './TripDetails.scss';

const TripDetails = ({
  detailsToggled,
  trip: { destination, displaySeatsLeft, startDate, endDate, content },
}) => (
  <div id="trip-details" className="trip-details row">
    {detailsToggled ? (
      ''
    ) : (
      <h3 className="h1-style muted">
        {destination},{' '}
        {formatDate(moment(startDate, 'MMMM Do, YYYY'), moment(endDate, 'MMMM Do, YYYY'))}!
      </h3>
    )}
    {(content.videoUrl || content.imageUrl) && content.description ? (
      <div className="col-md-4 padding-right">
        {!content.videoUrl || content.videoUrl === undefined ? (
          <img className="trip-image" src={`${content.imageUrl}`} alt={destination} />
        ) : (
          <div className="resp-container">
            <iframe
              id={content.id}
              className="resp-iframe"
              title="add-on video"
              frameBorder="0"
              padding="0"
              margin="0"
              allowFullScreen
              allow="autoplay; encrypted-media"
              src={content.videoUrl.replace('youtu.be/', 'www.youtube.com/embed/')}
            />
          </div>
        )}
      </div>
    ) : (
      ''
    )}
    {content.description ? (
      <div
        className={`no-padding-col ${
          content.imageUrl || content.videoUrl ? 'col-md-8' : 'col-md-12'
        }

        `}
      >
        <p className="trip-description no-margin-text">{content.description}</p>
        {displaySeatsLeft <= 10 ? (
          <p className="error">
            {displaySeatsLeft === 1 || displaySeatsLeft <= 0 ? '' : 'Hurry, only '}
            {seatsLeftEvaluator(displaySeatsLeft)}
          </p>
        ) : (
          ''
        )}
      </div>
    ) : (
      ''
    )}
  </div>
);

TripDetails.propTypes = {
  trip: PropTypes.shape({
    destination: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    content: PropTypes.shape({
      videoUrl: PropTypes.string,
      imageUrl: PropTypes.string,
      description: PropTypes.string,
    }),
  }).isRequired,
  detailsToggled: PropTypes.bool.isRequired,
};

export default TripDetails;
